var WDN = WDN || {};

// Main window resize listener
(function () {
  var handleWindowResize;
  var windowWidth = window.innerWidth;

  handleWindowResize = function () {
    if (windowWidth === window.innerWidth) return;
    window.dispatchEvent(new CustomEvent("window:resize", { detail: {} }));
    windowWidth = window.innerWidth;
  };

  window.addEventListener("resize", WDN.Debounce(handleWindowResize, 50));
})();

if (typeof WDN.ProductForm === "undefined") {
  WDN.ProductForm = (function () {
    var init, handleFormSubmit;

    var nodes = {
      listener: document.querySelector("[data-product-form-listener]"),
    };

    handleFormSubmit = function (e) {
      if (e.target.getAttribute("data-product-form") !== "") return;

      var addFormData = e.target.formData;

      /* plsfix: temp. support for selling plan */
      var selectedVariantItem = e.target.querySelector(
        'input[name="variant_selection"]:checked'
      );


      if (selectedVariantItem) {
        if (selectedVariantItem.hasAttribute("data-selling-plan-id")) {
          var sellingPlanId = selectedVariantItem.getAttribute(
            "data-selling-plan-id"
          );

          addFormData.append("selling_plan", sellingPlanId);
        }
      }
      /* end plsfix: temp. support for selling plan */

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        body: addFormData,
      })
        .then((response) => {
          return response.json();
        })
        .then((resJSON) => {
          document.body.dispatchEvent(
            new CustomEvent("cart:updated", { detail: resJSON })
          );
          WDN.CartDrawer.refresh({
            openDrawer: !e.target.hasAttribute("data-ignore-drawer"),
          });
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    };

    init = function () {
      if (!nodes.listener) return;
      nodes.listener.addEventListener("simple-form:submit", handleFormSubmit);
    };

    init();
  })();
}

if (typeof WDN.StylesheetLoader === "undefined") {
  WDN.StylesheetLoader = (function () {
    var load;

    load = function (selector) {
      if (!selector) return;
      document.querySelectorAll(selector).forEach(function (element) {
        if (element.getAttribute("media") === "all") return;
        element.setAttribute("media", "all");
      });
    };

    return {
      load,
    };
  })();
}

(function () {
  var nodes = document.querySelectorAll(".link\\:arrow");
  var icon =
    '<svg xmlns="http://www.w3.org/2000/svg" width="20.49" height="14.016" viewBox="0 0 20.49 14.016"><g id="Group_4349" data-name="Group 4349" transform="translate(-820.748 -636.311)"><path id="Path_2" data-name="Path 2" d="M18779.748,641.5h19.424" transform="translate(-17959 1.777)" fill="none" stroke="currentColor" stroke-width="1.5"/><path id="Path_3" data-name="Path 3" d="M18794.91,636.843l6.5,6.477-6.5,6.477" transform="translate(-17961.232 0)" fill="none" stroke="currentColor" stroke-width="1.5"/></g></svg>';

  nodes.forEach(function (node) {
    if (node.hasAttribute("data-no-icon")) return;
    node.insertAdjacentHTML("beforeend", icon);
  });
})();

/* Image missing [alt] logger */
(function () {
  var allImages = [...document.querySelectorAll("img")];
  var allImagesWithoutAlt = allImages.filter((img) => !img.hasAttribute("alt"));
  var allImagesWithEmptyAlt = allImages.filter(
    (img) => img.hasAttribute("alt") && img.getAttribute("alt") === ""
  );
  var groupTitles = [
    "%cWDN - Missing ALT Finder",
    "%cWDN - Missing ALT Finder (Verbose)",
  ];
  var groupStyling = [
    "background-color:white;font-size:16px;padding:5px;",
    "background-color:black;color:white;font-size:16px;padding:5px;",
  ];

  var findNames = (verbose = false) => {
    return [...allImagesWithoutAlt, ...allImagesWithEmptyAlt].map((img) => {
      var srcSplit =
        img.hasAttribute("src") && img.getAttribute("src").split("/");
      if (!srcSplit) return;
      var name = srcSplit[srcSplit.length - 1].split("?")[0];

      if (verbose)
        return {
          name: name,
          parentSection: img.closest(".shopify-section"),
          element: img,
        };
      return "Navn: " + name;
    });
  };

  groupTitles.forEach((title, idx) => {
    console.log(title, groupStyling[idx], findNames(idx));
  });
})();

// Cart upsell validator
(function () {
  // Listen for cart remove
  document.body.addEventListener("cart_item:removed", function (e) {
    // Fetch cart JSON
    fetch(`${Shopify.routes.root}cart.json`)
      .then((res) => res.json())
      .then((resJSON) => {
        let payload = {};

        // Loop through cart items
        resJSON.items.forEach((item) => {
          // Check if item has upsell property
          let upsellReference = item.properties["_upsell_product"]; // References Kit product ID
          if (!upsellReference) return;
          // Find Kit tied to an upsell
          let foundKit = resJSON.items.filter(
            (item) => item.product_id === parseInt(upsellReference)
          )[0];
          if (foundKit) return;

          payload = { id: item.key, quantity: 0 };
        });

        // If payload blank, stop the script
        if (Object.keys(payload).length === 0) return;

        // Send request to cart change and remove upsell product from the cart
        fetch(`${Shopify.routes.root}cart/change.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }).then((res) => {
          if (res.ok) {
            if (WDN.CartDrawer) {
              WDN.CartDrawer.refresh();
            } else {
              WDN.CartPage.refresh();
            }
          }
        });
      });
  });
})();

class ClickToCopy extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.formSubmit = this.form.querySelector('button[type="submit"]');
    this.textToCopy = this.form.querySelector('input[name="text-to-copy"]');
    this.formStatusOnCopy = "copied";
  }

  onCopySuccess() {
    this.setAttribute("data-" + this.formStatusOnCopy, "");
    this.dispatchEvent(new CustomEvent("text:copied"));
    this.formSubmit.disabled = true;

    if (this.form.querySelector('input[name="button_label_on_submit"]')) {
      this.formSubmit.innerText = this.form.querySelector(
        'input[name="button_label_on_submit"]'
      ).value;
    }
  }

  copyToClipboard() {
    this.textToCopy.type = "text";
    this.textToCopy.select();
    this.textToCopy.setSelectionRange(0, 9999);
    this.textToCopy.type = "hidden";
    navigator.clipboard
      .writeText(this.textToCopy.value)
      .then(() => {
        this.onCopySuccess();
      })
      .catch((err) => console.error("Couldn't clone code...? ", err));
  }

  connectedCallback() {
    this.form.addEventListener("submit", (e) => {
      e.preventDefault();
      this.copyToClipboard();
    });
  }
}

customElements.define("copy-text", ClickToCopy);
